@if (
  {
    results: (currentResults | async) || [],
    secondTabResults: (secondTabResults | async) || [],
    isvalid: searchService.searches[ServiceType.Hotel].isValid | async,
    isLoading: (searchParams.isLoading | async),
    jitRulesReceived: (searchParams.jitRulesReceived | async),
    fetching: (hotelAvalibilityService.fetching | async)
  };
  as data
) {
  <h2 class="visuallyhidden" i18n="@@hotel_searchCriteria">Search Criteria</h2>
  <a
    href="#hotel-search-1"
    (click)="skipToResultContent()"
    role="link"
    class="sr-only sr-only-focusable"
    >Skip to result content</a
  >
  <app-invoked-user></app-invoked-user>
  <app-hotel-loading-screen
    [showOverride]="!data.results?.length && data.fetching"
    [animated]="false"
  ></app-hotel-loading-screen>
  @if (originalResultsNotFound$ | async) {
    <div class="light-error-box">
      <p i18n="@@hotel_original_results_expired">
        This hotel search result is no longer available. Please start a new search.
      </p>
      <a
        class="light-btn light-btn-primary"
        routerLink="/search"
        i18n="@@hotel_original_results_start_new_search"
        >Start a new hotel search</a
      >
    </div>
  }
  @if (!data.isLoading) {
    <div>
      <div class="background-container-background research-container">
        <app-search-toggle [serviceType]="ServiceType.Hotel">
          <app-hotel-search class="search-toggle"></app-hotel-search>
          <div>
            <div class="flex-row-container flex-row-container--right">
              <button
                type="button"
                (click)="performSearch()"
                [disabled]="!data.isvalid"
                appButton="large-search"
                i18n="@@hotel_Search"
              >
                Search
              </button>
            </div>
          </div>
        </app-search-toggle>
      </div>
      @if (searchParams.tempParams.location_type_select) {
        <app-risk-alerts [countryCode]="getCountryCode()"> </app-risk-alerts>
      }
      <!-- results grid -->
      <div class="hotel_search_results" id="hotel-search-1">
        <div class="flex-row-container flex-column-mobile">
          <div class="flex-column-container results-width">
            <section class="container">
              @if (searchParams.backToType) {
                @switch (searchParams.backToType) {
                  @case (ServiceType.Flight) {
                    <button
                      appButton="small"
                      class="back-to-button"
                      id="hotel-button-back-to-flights"
                      i18n="@@backToFlightsTrainlineEu"
                      routerLink="/results/flights"
                    >
                      <i class="ico-flight" aria-hidden="true"></i>
                      Back to Flights
                    </button>
                  }
                  @case (ServiceType.Car) {
                    <button
                      appButton="small"
                      class="back-to-button"
                      id="hotel-button-back-to-car"
                      routerLink="/results/cars"
                    >
                      <i class="ico-car" aria-hidden="true"></i>
                      <span i18n="@@backToCarHire">Back to car hire</span>
                    </button>
                  }
                  @case (ServiceType.Eurostar) {
                    <button
                      appButton="small"
                      class="back-to-button"
                      id="hotel-button-back-to-eurostar"
                      routerLink="/results/eurostar"
                    >
                      <i class="custom_icon-eurostar" aria-hidden="true"></i>
                      <span i18n="@@backToEurostar">Back to Eurostar</span>
                    </button>
                  }
                  @case (ServiceType.Rail) {
                    <button
                      appButton="small"
                      class="back-to-button"
                      id="hotel-button-back-to-rail"
                      routerLink="/results/rail"
                    >
                      <i class="ico-rail" aria-hidden="true"></i>
                      <span i18n="@@backToRail">Back to rail</span>
                    </button>
                  }
                }
              }
            </section>
            <div class="flex-column-container width-100">
              <div class="search_results_header">
                <div class="flex-row-container flex-row-container--between flex-column-mobile">
                  <p class="search_results_page_title">
                    <span [innerHtml]="getNumHotelsMsg()" role="status"></span>
                  </p>
                  @if (!data.isLoading && data.results[0]?.co2PerItem) {
                    <div class="co2-ontainer">
                      <span>
                        <span i18n="@@Hotelsatthisdestinationcontribute"
                          >Hotels at this destination contribute
                        </span>
                        <strong> {{ co2Number }}kg <span i18n="@@ofCO2">of CO2 </span></strong>
                        <span i18n="@@perNight">per night</span></span
                      >
                      @if (themeService.isLightningEnv) {
                        <a
                          class="carbon_link"
                          href="https://uk.travelctm.com/guide-to-ctm-carbon-emissions-calculations/ "
                          tabindex="0"
                          target="_blank"
                          ><i class="ico-info-circle" aria-hidden="true"></i>
                          <span i18n="@@howCtmCalculates"
                            >&nbsp;How CTM calculates carbon emissions</span
                          >
                        </a>
                      }
                      @if (themeService.isScionEnv) {
                        <span i18n="@@howDefraCalculates"
                          >&nbsp;We use Defra calculations to show hotel carbon impact by
                          location</span
                        >
                      }
                    </div>
                  }
                </div>
              </div>
              <div class="sort_results_actions">
                <!-- Sort and Filtering Options -->
                <!-- Sort -->
                <div class="filter-sort flex-column-mobile">
                  @if (!data.isLoading && data.results?.length) {
                    <app-sort
                      [sortTypes]="sortTypes"
                      [sortType]="sortType"
                      (sortChange)="onSortChange($event)"
                      [type]="ServiceType.Hotel"
                    >
                    </app-sort>
                  }
                  <div class="flex-column-container filter-container">
                    <span class="extras-label"> Filter: </span>
                    <app-filter-hotels
                      (availabilityFilter)="setAvailabilityFilterState($event)"
                      [srchRslts]="searchParams.searchResults"
                      [hotels]="searchParams.searchResults"
                      [viewControl]="hotelViewController"
                      [swapSellHotelGroup]="swapSellHotelGroup"
                    ></app-filter-hotels>
                  </div>
                </div>
                <span class="more-results-info light-flex light-center">
                  <section (mouseleave)="tt.close()" class="container">
                    <i
                      class="ico-info"
                      [ngbTooltip]="moreInfo | translate"
                      placement="auto"
                      triggers="manual"
                      #tt="ngbTooltip"
                      (mouseenter)="tt.open()"
                      (focus)="tt.open()"
                      (blur)="tt.close()"
                      tabindex="0"
                    ></i>
                  </section>
                  <span i18n="@@hotelsNeedResults">Need more results?</span>
                </span>
                <div class="flex-row-container">
                  <div
                    (click)="setView(HotelView.LIST)"
                    (keydown.enter)="setView(HotelView.LIST)"
                    [ngClass]="{ 'ico-thumbnails-active': view === HotelView.LIST }"
                    class="ico-thumbnails"
                    i18n-title
                    title="See hotels as list"
                    aria-label="See hotels as list"
                    tabindex="0"
                    role="button"
                    attr.aria-expanded="{{ !hotelViewController.showMap }}"
                    attr.aria-current="{{ hotelViewController.showMap ? 'false' : 'page' }}"
                  ></div>
                  <div
                    [ngClass]="{ 'ico-locale-active': view === HotelView.MAP }"
                    (click)="setView(HotelView.MAP)"
                    (keydown.enter)="setView(HotelView.MAP)"
                    class="ico-locale"
                    i18n-title
                    title="See hotels as map"
                    tabindex="0"
                    aria-labelledby="hotels-see-as-map"
                    role="button"
                    attr.aria-expanded="{{ hotelViewController.showMap }}"
                    attr.aria-current="{{ hotelViewController.showMap ? 'page' : 'false' }}"
                  >
                    <span id="HotelsMapView" aria-hidden="true" i18n="@@HotelsMapView">
                      Map view
                    </span>
                  </div>
                </div>
              </div>
              <app-filter-pills
                [filters]="searchParams.filters"
                [serviceType]="ServiceType.Hotel"
              ></app-filter-pills>
              @if (data.results.length <= 0 && searchParams.crownRatesOnly && data.fetching) {
                <div>
                  <h2 class="no_results_message_heading" i18n="@@crownRatesOnlyLoading">
                    Loading...
                  </h2>
                </div>
              }
              <div
                role="status"
                [ngClass]="{
                  visuallyhidden: !(
                    data.results.length <= 0 &&
                    (!searchParams.crownRatesOnly ||
                      (searchParams.crownRatesOnly && !data.fetching))
                  )
                }"
              >
                @if (data.results.length <= 0 && !searchParams.crownRatesOnly && !data.fetching) {
                  <app-no-results></app-no-results>
                }
              </div>
              <div class="hotel-pref-message">
                @if (showPreferredMessage && !isPrefHotelsSelected()) {
                  <span>
                    <b
                      class="back_to_search"
                      (click)="switchTriggerPref(showPreferredMessage)"
                      role="button"
                      >CLICK HERE</b
                    >
                    @if (showPreferredMessage === 'trigger') {
                      <span>
                        to discover alternative hotels and enjoy up to *10% off by booking CTM's
                        preferred programme *Discount applies to select properties in the CTM
                        Preferred Hotel Programme*</span
                      >
                    }
                    @if (showPreferredMessage === 'preferred') {
                      <span> to return to previous results</span>
                    }
                  </span>
                }
              </div>
              @if (isPrefHotelsSelected()) {
                <div>
                  <span class="back_to_search" (click)="backToHotelModal()" role="button"
                    >CLICK HERE</span
                  >
                  to return to previous results
                </div>
              }
              <div class="hotel_search_results_items clearfix" id="hotel-results-container">
                <!-- LIST VIEW-->
                @if (!hotelViewController.showMap) {
                  <!-- individual hotel item -->
                  @if (!hotelViewController.showMap && hotelViewController.hotelChosen !== false) {
                    <div class="hotel-results-container">
                      <div class="list-actions">
                        <a
                          class="light-btn-link light-color-primary imp"
                          (click)="setView(HotelView.LIST)"
                          i18n="@@hotelsBackToList"
                          role="link"
                          >Back to full list</a
                        >
                      </div>
                      @if (searchParams?.results?.value[hotelViewController.hotelChosen]) {
                        @if (
                          {
                            rooms:
                              (hotelAvalibility[hotelViewController.hotelCodeChosen] | async) || {},
                            hotelRating:
                              (hotelRatings[
                                selectedHotelOnTheMap(
                                  hotelViewController.hotelCodeChosen
                                )?.name?.toLowerCase()
                              ] | async) || {},
                            hotelGroupTags:
                              (hotelGroupTags[
                                selectedHotelOnTheMap(
                                  hotelViewController.hotelCodeChosen
                                )?.group?.toLowerCase()
                              ] | async) || {}
                          };
                          as subdata
                        ) {
                          @if (
                            !availabilityFilterState ||
                            (availabilityFilterState && subdata?.rooms?.prpn)
                          ) {
                            <app-item-hotels
                              inview
                              (inViewChanged)="
                                fetchPrices(
                                  $event,
                                  searchParams?.results?.value[hotelViewController.hotelChosen]
                                )
                              "
                              [hotelDetail]="
                                selectedHotelOnTheMap(hotelViewController.hotelCodeChosen)
                              "
                              [holidayCode]="hotelViewController.hotelCodeChosen"
                              [rooms]="subdata.rooms"
                              [noOfRooms]="noOfRooms"
                              [jitRulesReceived]="data.jitRulesReceived"
                              [viewControl]="hotelViewController"
                              (changeFilter)="changeFilter($event)"
                              [index]="1"
                              [distanceUnit]="userDistanceUnit"
                              [localCurrency]="userLocalCurrency"
                              [hotelRatingsInfo]="subdata?.hotelRating"
                              [hotelGroupTags]="subdata?.hotelGroupTags"
                            >
                            </app-item-hotels>
                          }
                        }
                      }
                    </div>
                  }
                  @if (!searchParams?.results?.value[hotelViewController.hotelChosen]) {
                    @if (data.results.length && data.secondTabResults.length) {
                      <app-light-toggle-group tabindex="-1" class="hotel-tabs">
                        <app-light-toggle-btn
                          [selected]="secondTabSelected === false"
                          id="hotel-search-results-tab"
                          (click)="secondTabSelected = false"
                          tabindex="-1"
                          i18n="@@hotelsTabSearchResults"
                        >
                          Search results
                        </app-light-toggle-btn>
                        <app-light-toggle-btn
                          [selected]="secondTabSelected === true"
                          id="hotel-other-results-tab"
                          (click)="secondTabSelected = true"
                          tabindex="-1"
                          i18n="@@hotelsTabOtherLondonOptions"
                        >
                          Other London options
                        </app-light-toggle-btn>
                      </app-light-toggle-group>
                    }
                    <!-- Complete list of hotels -->
                    @if ((secondTabSelected ? data.secondTabResults : data.results)?.length) {
                      <ul class="hotel-results-list">
                        @for (
                          itemHotel of secondTabSelected ? data.secondTabResults : data.results;
                          track itemHotel;
                          let i = $index
                        ) {
                          <li
                            class="hotel-list-item"
                            role="group"
                            [attr.aria-label]="
                              'Hotel option ' +
                              (i + 1) +
                              ': ' +
                              itemHotel.name +
                              (itemHotel.address ? ', ' + itemHotel.address : '')
                            "
                          >
                            @if (
                              i < maxResultSize && {
                                rooms: (hotelAvalibility[itemHotel.id] | async) || {},
                                hotelRating:
                                  (hotelRatings[itemHotel?.name?.toLowerCase()] | async) || {},
                                hotelGroupTags:
                                  (hotelGroupTags[itemHotel?.group?.toLowerCase()] | async) || {}
                              };
                              as subdata
                            ) {
                              <!--
                                          DEV NOTE:
                                          only show the hotel in the list if the availabilityFilterState property is "false" OR
                                          the availabilityFilterState property is "true" and a price is available in the subdata.rooms.prpn property.
                                        -->
                              @if (
                                !availabilityFilterState ||
                                (availabilityFilterState && subdata?.rooms?.prpn)
                              ) {
                                <app-item-hotels
                                  inview
                                  (inViewChanged)="fetchPrices($event, itemHotel)"
                                  [hotelDetail]="itemHotel"
                                  [holidayCode]="itemHotel.id"
                                  [rooms]="subdata.rooms"
                                  [noOfRooms]="noOfRooms"
                                  [jitRulesReceived]="data.jitRulesReceived"
                                  [viewControl]="hotelViewController"
                                  (changeFilter)="changeFilter($event)"
                                  [index]="i + 1"
                                  [distanceUnit]="userDistanceUnit"
                                  [localCurrency]="userLocalCurrency"
                                  [hotelRatingsInfo]="subdata?.hotelRating"
                                  [hotelGroupTags]="subdata?.hotelGroupTags"
                                >
                                </app-item-hotels>
                              }
                            }
                          </li>
                        }
                      </ul>
                    }
                  }
                }
                <!-- MAP VIEW-->
                @if (hotelViewController.showMap) {
                  @if (hotelViewController.single) {
                    <div class="hotel-map-results">
                      <app-map-hotels
                        [noOfRooms]="noOfRooms"
                        (afterBackToList)="setView(HotelView.LIST)"
                        [arrayOfHotels]="this.hotelViewController.hotelChosen"
                        [mapControl]="hotelViewController"
                      ></app-map-hotels>
                    </div>
                  }
                  @if (!hotelViewController.single) {
                    <div class="hotel-map-results">
                      <app-map-hotels
                        [noOfRooms]="noOfRooms"
                        (afterBackToList)="setView(HotelView.LIST)"
                        [arrayOfHotels]="data.results"
                        [mapControl]="hotelViewController"
                      ></app-map-hotels>
                    </div>
                  }
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
}
